import { Record, Map } from "immutable";

const FormsRecord = Record({
  changePassword: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      currentPassword: "",
      password: "",
      passwordConfirm: ""
    }))()
  }))(),
  changeProfileDatas: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      fullName: ""
    }))()
  }))(),
  twoFactorAuth: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    qrCode: "",
    dirty: false,
    fields: new (Record({
      token: "",
      currentPassword: "",
      is2FA: false
    }))()
  }))(),
  forgot: new (Record({
    sent: false,
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      email: ""
    }))()
  }))(),
  setPassword: new (Record({
    sent: false,
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      password: "",
      passwordConfirm: "",
      token: ""
    }))()
  }))(),
  createUser: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      email: "",
      groupName: "user"
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/users/forms.js